import { createQueryKeys } from '@lukemorales/query-key-factory';

export const manualsQueries = createQueryKeys('manuals', {
  list: null,
});
